@import '../../styles/typography.css';
@import '../../styles/colors.css';
@import '../../styles/layout.css';

/* Prevents PruneVar from removing the colors var used by JS */
{
  color: var(--totem-text-color-link);
  color: var(--totem-text-color-link-hover);
  color: var(--totem-text-color-link-pressing);
}

:host {
  display: block;
  font-family: var(--totem-font-family-web);
}

:host([weight='regular']) ::slotted(*) {
  font-weight: var(--totem-font-weight-400);
}

:host([weight='bold']) ::slotted(*) {
  font-weight: var(--totem-font-weight-700);
}

:host([weight='light']) ::slotted(*) {
  font-weight: var(--totem-font-weight-300);
}

:host([italic='']) ::slotted(*),
:host([italic='true']) ::slotted(*) {
  font-style: italic;
}

:host([underline='']) ::slotted(*),
:host([underline='true']) ::slotted(*) {
  text-decoration: underline;
}

:host([variant='display-black']) ::slotted(*) {
  font-size: var(--totem-font-size-800);
  font-weight: var(--totem-font-weight-900);
  line-height: var(--totem-font-lh-800);
}

@media (--totem-breakpoint-sm) {
  :host([variant='display-black']) ::slotted(*) {
    font-size: var(--totem-font-size-900);
    line-height: var(--totem-font-lh-900);
  }
}

:host([variant='title-30']) ::slotted(*) {
  font-size: var(--totem-font-size-900);
  line-height: var(--totem-font-lh-900);
}

:host([variant='title-26']) ::slotted(*) {
  font-size: var(--totem-font-size-700);
  line-height: var(--totem-font-lh-700);
}

:host([variant='title-24']) ::slotted(*) {
  font-size: var(--totem-font-size-600);
  line-height: var(--totem-font-lh-600);
}

:host([variant='title-20']) ::slotted(*) {
  font-size: var(--totem-font-size-500);
  line-height: var(--totem-font-lh-500);
}

:host([variant='title-16']) ::slotted(*) {
  font-size: var(--totem-font-size-300);
  line-height: var(--totem-font-lh-300);
}

:host([variant='body-16']) ::slotted(*) {
  font-size: var(--totem-font-size-300);
  line-height: var(--totem-font-lh-300);
}

:host([variant='body-14']) ::slotted(*) {
  font-size: var(--totem-font-size-200);
  line-height: var(--totem-font-lh-200);
}

:host([variant='body-12']) ::slotted(*) {
  font-size: var(--totem-font-size-100);
  line-height: var(--totem-font-lh-400);
}

:host([variant='asset-number-60']) ::slotted(*) {
  font-size: var(--totem-font-size-1100);
  font-weight: var(--totem-font-weight-700);
  line-height: var(--totem-font-lh-1100);
}

:host([variant='asset-number-40']) ::slotted(*) {
  font-size: var(--totem-font-size-1000);
  font-weight: var(--totem-font-weight-700);
  line-height: var(--totem-font-lh-1000);
}
